import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import cn from "classnames";
import {Link} from "react-router-dom";
import Lightbox from "react-image-lightbox";
import {useState} from "react";

function OrderingCard({
                          id,
                          restaurant,
                          customer,
                          ownOrder = false,
                          inOrder = false,
                          mayConfirm = false,
                          timeOfOrdering,
                          timeTillOrering,
                          calling,
                          paymentMethodes,
                          disabled = false,
                          interaction = true,
                          called = false,
                          finished = false,
                          paypalEmail,
                      }) {

    const [isOpen, setIsOpen] = useState(false)

    const handleOpenMenu = e => {
        e.preventDefault()
        e.stopPropagation()

        setIsOpen(true)
    }

    return (
        <div className="card shadow mb-3">
            <div className="card-body">
                <h5 className="card-title"><FontAwesomeIcon className="text-primary"
                                                            icon={restaurant.icon}/> Bestellung
                    bei <b>{restaurant.name}</b></h5>
                <h6 className="card-subtitle mb-3 text-muted">{customer}</h6>
                <div className="card-text row">
                    <div className="col-md">
                        <div>
                            <div className="fw-bold">
                                <FontAwesomeIcon className="text-primary" icon={["fas", "clock"]}/> Für wann wird
                                bestellt?
                            </div>
                            <div className="ps-5">{timeOfOrdering}</div>
                        </div>
                        <div>
                            <div className="fw-bold">
                                <FontAwesomeIcon className="text-primary" icon={["fas", "history"]}/> Bis wann kann ich
                                bei der Bestellung mit machen?
                            </div>
                            <div className="ps-5">{timeTillOrering}</div>
                        </div>
                    </div>
                    <div className="col-md">
                        <div>
                            <div className="fw-bold">
                                <FontAwesomeIcon className="text-primary" icon={["fas", "phone"]}/> Wer ruft an?
                            </div>
                            <div className="ps-5">{calling}</div>
                        </div>
                        <div>
                            <div className="fw-bold">
                                <FontAwesomeIcon className="text-primary" icon={["fas", "euro-sign"]}/> Wie kann ich
                                bei <span className="text-primary">{customer}</span> bezahlen?
                            </div>
                            <div className="ps-5">
                                {
                                    paymentMethodes.map(e => <span key={e.name} className="me-2"><FontAwesomeIcon
                                        className="text-primary" icon={e.icon}/> {e.name}</span>)
                                }
                            </div>
                        </div>
                        {
                            paypalEmail && paypalEmail !== "" ? (
                                <div>
                                    <div className="fw-bold">
                                        <FontAwesomeIcon className="text-primary" icon={["fas", "envelope"]}/> Wie ist
                                        die PayPal-Adresse von <span className="text-primary">{customer}</span>?
                                    </div>
                                    <div className="ps-5">
                                        {paypalEmail}
                                    </div>
                                </div>
                            ) : null
                        }
                    </div>
                </div>
                {
                    interaction ? (
                        <div className="float-end">
                            <div className="btn-group" role="group">
                                {
                                    mayConfirm === true && ownOrder === false ? (
                                        <Link to={"/orders/" + id}
                                              className={cn("btn btn-outline-danger")}>ansehen (Verwaltung)</Link>
                                    ) : null
                                }
                                {
                                    ownOrder === true || inOrder === true ? (
                                        <Link to={"/orders/" + id}
                                              className={cn("btn btn-outline-warning")}>ansehen</Link>
                                    ) : finished === true ? (
                                        <button onClick={e => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                        }}
                                                className={cn(
                                                    "btn btn-danger text-light",
                                                    {"disabled": disabled},
                                                )}>Diese Bestellung ist abgeschlossen</button>
                                    ) : called ? (
                                        <button onClick={e => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                        }}
                                                className={cn(
                                                    "btn btn-warning text-light",
                                                    {"disabled": disabled},
                                                )}>es wurde schon angerufen!</button>
                                    ) : (
                                        <Link to={"/orders/" + id}
                                              className={cn(
                                                  "btn btn-primary text-light",
                                                  {"disabled": disabled},
                                              )}>mit bestellen?</Link>
                                    )

                                }
                            </div>
                        </div>
                    ) : restaurant.id && restaurant.id !== "-1" ? (
                        <div className="float-end">
                            <div className="">
                                <Link to={"/menu/" + restaurant.id} className="btn btn-primary text-light"
                                      target="_blank">Karte
                                    öffnen
                                </Link>
                                {isOpen && (
                                    <Lightbox
                                        mainSrc={"/karten/" + restaurant.id + ".jpg"}
                                        onCloseRequest={() => setIsOpen(false)}
                                    />
                                )}
                            </div>
                        </div>
                    ) : null

                }
            </div>
        </div>
    )
}

export default OrderingCard;